import React, { useState } from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import CircularProgress from '@material-ui/core/CircularProgress'
import { Auth } from 'aws-amplify'
import ProviderAPI from 'config/api/ProviderAPI'

function CompanyNotFound({ companyUrl, email }) {
    const [requestedUrl, setRequestedUrl] = useState('')
    const [sending, setSending] = useState(false)
    const [sent, setSent] = useState(false)
    const [error, setError] = useState(null)

    const api = new ProviderAPI()

    async function handleLogout() {
        await Auth.signOut()
        window.location.replace('/')
    }

    async function handleSendRequest() {
        if (!requestedUrl.trim()) return
        setSending(true)
        setError(null)
        try {
            await api.requestUrlChange(email, companyUrl, requestedUrl.trim())
            setSent(true)
        } catch (e) {
            console.error('Error sending URL change request:', e)
            setError('There was a problem sending your request. Please email declan@bq.ie directly.')
        } finally {
            setSending(false)
        }
    }

    return (
        <Box
            display='flex'
            justifyContent='center'
            alignItems='center'
            minHeight='100vh'
            bgcolor='#f5f5f5'
            padding='1rem'
        >
            <Card style={{ maxWidth: 520, width: '100%' }}>
                <CardContent>
                    <Box display='flex' flexDirection='column' alignItems='center'>
                        <Box
                            component={Typography}
                            variant='h3'
                            marginBottom='1rem!important'
                            textAlign='center'
                        >
                            Company Not Found
                        </Box>

                        <Box
                            component='p'
                            marginBottom='0.5rem'
                            fontWeight='300'
                            lineHeight='1.7'
                            fontSize='1rem'
                            marginTop='0'
                            textAlign='center'
                        >
                            We couldn't find your company using the URL stored in your account. This is usually caused by a typo when the account was set up.
                        </Box>

                        <Box
                            bgcolor='#f0f0f0'
                            borderRadius='4px'
                            padding='0.6rem 1rem'
                            marginBottom='1.5rem'
                            width='100%'
                            textAlign='center'
                        >
                            <Typography variant='caption' style={{ display: 'block', color: '#888', marginBottom: 2 }}>
                                URL currently on your account
                            </Typography>
                            <Typography variant='body2' style={{ fontFamily: 'monospace', wordBreak: 'break-all' }}>
                                {companyUrl || '(none set)'}
                            </Typography>
                        </Box>

                        {!sent ? (
                            <>
                                <Box width='100%' marginBottom='1rem'>
                                    <TextField
                                        fullWidth
                                        variant='outlined'
                                        label='Correct company URL'
                                        placeholder='e.g. mycompany.ie'
                                        value={requestedUrl}
                                        onChange={(e) => setRequestedUrl(e.target.value)}
                                        size='small'
                                    />
                                </Box>

                                {error && (
                                    <Box marginBottom='1rem' width='100%'>
                                        <Typography variant='body2' color='error' align='center'>
                                            {error}
                                        </Typography>
                                    </Box>
                                )}

                                <Button
                                    variant='contained'
                                    color='primary'
                                    fullWidth
                                    disabled={sending || !requestedUrl.trim()}
                                    onClick={handleSendRequest}
                                    style={{ marginBottom: '0.75rem' }}
                                >
                                    {sending ? <CircularProgress size={20} color='inherit' /> : 'Request URL Change'}
                                </Button>
                            </>
                        ) : (
                            <Box
                                bgcolor='#e8f5e9'
                                borderRadius='4px'
                                padding='0.75rem 1rem'
                                marginBottom='1rem'
                                width='100%'
                                textAlign='center'
                            >
                                <Typography variant='body2' style={{ color: '#2e7d32' }}>
                                    Request sent. We'll update your account and let you know when it's done.
                                </Typography>
                            </Box>
                        )}

                        <Button
                            variant='text'
                            color='default'
                            size='small'
                            onClick={handleLogout}
                        >
                            Log out
                        </Button>
                    </Box>
                </CardContent>
            </Card>
        </Box>
    )
}

export default CompanyNotFound
